























































import { Component, Prop } from 'vue-property-decorator'

import UiButton from '@/components/semantic-ui/Button'
import UiModal from '@/components/semantic-ui/Modal.vue'
import UiSelectionDropdown from '@/components/semantic-ui/SelectionDropdown.vue'

import { Brand, PantryItem } from '@/datastore/models'

import grocery from '@/store/modules/grocery'

@Component({
	components: {
		UiButton,
		UiModal,
		UiSelectionDropdown,
	},
})
export default class AddToShoppingListModal extends UiModal {

	@Prop({ required: true })
	readonly item!: PantryItem

	notes = ''

	preferredBrands: string[] = []

	quantity = 1

	get brands(): Brand[] {

		return grocery.brands.filter(brand => grocery.pantryItemBrands[this.item.$id].includes(brand.$id))
	}

	protected get isValid(): boolean {

		return typeof this.quantity === 'number'
	}

}

